import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { jsx } from "@emotion/core";
import { fonts } from "../..";
export var Display = function Display(_ref) {
  var _ref$level = _ref.level,
      level = _ref$level === void 0 ? "1" : _ref$level,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? "span" : _ref$renderAs,
      children = _ref.children;
  return jsx(renderAs, {
    css: _objectSpread(_objectSpread({}, fonts[level === "1" ? "display-1" : "display-2"]), {}, {
      margin: 0
    })
  }, children);
};
export var Heading = function Heading(_ref2) {
  var _ref2$level = _ref2.level,
      level = _ref2$level === void 0 ? "1" : _ref2$level,
      _ref2$renderAs = _ref2.renderAs,
      renderAs = _ref2$renderAs === void 0 ? level === "1" ? "h1" : "h2" : _ref2$renderAs,
      children = _ref2.children;
  return jsx(renderAs, {
    css: _objectSpread(_objectSpread({}, fonts[level === "1" ? "heading-1" : "heading-2"]), {}, {
      margin: 0
    })
  }, children);
};
export var Body = function Body(_ref3) {
  var _ref3$level = _ref3.level,
      level = _ref3$level === void 0 ? "1" : _ref3$level,
      _ref3$renderAs = _ref3.renderAs,
      renderAs = _ref3$renderAs === void 0 ? "span" : _ref3$renderAs,
      _ref3$weight = _ref3.weight,
      weight = _ref3$weight === void 0 ? "normal" : _ref3$weight,
      children = _ref3.children;
  return jsx(renderAs, {
    css: _objectSpread(_objectSpread({}, fonts[level === "1" ? "body-1" : "body-2"]), {}, {
      margin: 0,
      fontWeight: fonts.weights[weight]
    })
  }, children);
};
export var Label = function Label(_ref4) {
  var _ref4$renderAs = _ref4.renderAs,
      renderAs = _ref4$renderAs === void 0 ? "label" : _ref4$renderAs,
      htmlFor = _ref4.htmlFor,
      children = _ref4.children;
  return jsx(renderAs, _objectSpread({
    css: _objectSpread(_objectSpread({}, fonts.label), {}, {
      margin: 0
    })
  }, renderAs === "label" ? {
    htmlFor: htmlFor
  } : null), children);
};